export const processDocForm: any = {
  doctypeId: "",
  doctypeName: "",
  documentName: "",
  documentNumbering: "",
  reasonOfCreation: "",
  currentVersion: "A",
  documentLink: "",
  description: "",
  tags: [],
  referenceDocuments: [],
  documentVersions: [],
  additionalReaders: [],
  creators: [],
  approvers: [],
  reviewers: [],
  distributionList: "None",
  retireComment:"",
  file: "",
  revertComment:"",
  entityId:"",
  locationName: "",
  departmentName: "",
  doctypes: [],
  readAccess: "",
  readAccessUsers: [],
  documentState: "",
  docsClassification: "",
  systems: [],
  issueNumber: "",
  distributionUsers: [],
  section: "",
  status:"new"
};
